import React from 'react';

const ProductCard = ({ product, onSelect, disabled, statusText }) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onSelect(product)}
      disabled={disabled}
      className={`w-full rounded-xl border border-gray-200 bg-white cursor-pointer h-[80px] px-2 shadow-sm transition ${
        disabled ? 'cursor-not-allowed opacity-60' : 'hover:-translate-y-0.5 hover:shadow-md hover:bg-gray-200'
      }`}
    >
      <div className="flex flex-col items-start gap-2">
        <div className="w-full">
          <h3 className="text-lg font-semibold text-gray-900 whitespace-normal break-words leading-tight">{product.name}</h3>
          <p className="text-sm text-gray-500 mt-1">PKR {product.price.toFixed(2)}</p>
          {statusText && <p className="mt-2 text-xs font-semibold text-red-600">{statusText}</p>}
        </div>
      </div>
    </button>
  );
};

export default ProductCard;
